import { ExamplePageTemplate } from "./components";
import { financialConfig } from "./configs/exampleConfigs";

const FinancialExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={financialConfig.backgroundColor}
      chatButtonColor={financialConfig.chatButtonColor}
      chatButtonIcon={financialConfig.chatButtonIcon}
      header={financialConfig.header}
      hero={financialConfig.hero}
    >
      {financialConfig.content}
    </ExamplePageTemplate>
  );
};

export default FinancialExample;